<p>pressure-detail-template works!</p>
